import { Route } from '@angular/router';
import { AuthGuard } from './auth/auth-guard/auth.guard';

export const appRoutes: Route[] = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () =>
      import('src/app/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: 'assignments',
    loadChildren: () =>
      import('src/app/assignments/assignments.routes').then(
        (m) => m.assignmentRoutes
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'accounts',
    loadChildren: () =>
      import('src/app/accounts/accounts.routes').then((m) => m.accountsRoutes),
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('src/app/dashboard/dashboard.component').then(
        (m) => m.DashboardComponent
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'orders',
    loadChildren: () =>
      import('src/app/orders/orders.routes').then((m) => m.ordersRoutes),
    canActivate: [AuthGuard],
  },
  {
    path: 'tables',
    loadChildren: () =>
      import('src/app/tables/tables.routes').then((m) => m.tablesRoutes),
    canActivate: [AuthGuard],
  },
];
